import BusinessIcon from "@mui/icons-material/Business";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import FoundationIcon from "@mui/icons-material/Foundation";
import { CgRename } from "react-icons/cg";

export function AsiakasIcon(props) {
  return <BusinessIcon {...props} />;
}

export function UusiAsiakasIcon(props) {
  return <AddBusinessIcon color="primary" {...props} />;
}

export function LisäNimiIcon(props) {
  return <CgRename color="primary" {...props} />;
}

export function TyomaaIcon(props) {
  return <FoundationIcon color="primary" {...props} />;
}
